<template>
  <div>

    <div v-if='location["verdieping-klankbordgroep"]'
         :class='classList'
         class='grid-item focus-group'>

      <div class='author small-text bold'>
        <span>{{item.title.rendered}}</span>
      </div>

      <div class='image-container'>
        <img v-if='language === "nl" && item.acf.image'
             v-lazy="item.acf.image.sizes['grid-small']">
        <img v-if='language === "en"'
             v-lazy="item.acf.image_en.sizes['grid-small']">
        <img v-if='language === "en" && !item.acf.image_en'
             v-lazy="item.acf.image.sizes['grid-small']">
      </div>

      <div v-if='language === "nl"'
           class='description secondary-color small-text'
           v-html='item.acf.excerpt'></div>
      <div v-if='language === "en"'
           class='description secondary-color small-text'
           v-html='item.acf.excerpt_en'></div>

    </div>

    <div v-if='location["nieuws"]'
         :class='classList'
         class='grid-item focus-group'>
      <a :href='item.acf.target_link'
         target=_blank>

        <div class='author small-text bold'>
          <span>{{item.title.rendered}}</span>
        </div>

        <div class='image-container'>
          <img v-if='language === "nl" && item.acf.image'
               v-lazy="item.acf.image.sizes['grid-small']">
          <img v-if='language === "en" && item.acf.image_en'
               v-lazy="item.acf.image_en.sizes['grid-small']">
          <img v-if='language === "en" && !item.acf.image_en'
               v-lazy="item.acf.image.sizes['grid-small']">
        </div>

        <div v-if='language === "nl"'
             class='description secondary-color small-text'
             v-html='item.acf.excerpt'></div>
        <div v-if='language === "en"'
             class='description secondary-color small-text'
             v-html='item.acf.excerpt_en'></div>

      </a>
    </div>

    <div v-if='!location["verdieping-klankbordgroep"] && !location["nieuws"] && item.acf !== false'
         :class='classList'
         class='grid-item'>

      <div class='author small-text bold'>
        <span>{{ item.acf.author }}</span>
      </div>

      <router-link v-if='location.verdieping'
                   :to="{name: item.slug, params: {language: language}}"
                   class='roman'>
        <div class='title'>
          <span v-if='language === "nl"'
                v-html='item.title.rendered'></span>
          <span v-if='language === "en"'
                v-html='item.acf.title_en'></span>
        </div>

        <div v-if='!screenSize.mobile'
             class='tags'>
          <dsTagItemInline v-for='tag in item.tags'
                           :tag="tag"
                           :tags='tags'
                           :language='language'></dsTagItemInline>
        </div>

        <div class='image-container'>
          <img v-if='language === "nl" && item.acf.image'
               v-lazy="item.acf.image.sizes['grid-small']">
          <img v-else-if='language === "en" && item.acf.image_en'
               v-lazy="item.acf.image_en.sizes['grid-small']">
          <img v-else
               v-lazy="item.acf.image.sizes['grid-small']">
        </div>
      </router-link>

      <router-link v-else
                   :to="{name: 'single', params: {language: language, slug: item.slug}}"
                   class='roman'>
        <div class='title'>
          <span v-if='language === "nl"'
                v-html='item.title.rendered'></span>
          <span v-if='language === "en"'
                v-html='item.acf.title_en'></span>
        </div>

        <div v-if='!screenSize.mobile'
             class='tags'>
          <dsTagItemInline v-for='tag in item.tags'
                           :tag="tag"
                           :tags='tags'
                           :language='language'></dsTagItemInline>
        </div>

        <div class='image-container'>
          <img v-if='language === "nl" && item.acf.image'
               v-lazy="item.acf.image.sizes['grid-small']">
          <img v-if='language === "en" && item.acf.image_en'
               v-lazy="item.acf.image_en.sizes['grid-small']">
          <img v-if='language === "en" && !item.acf.image_en'
               v-lazy="item.acf.image.sizes['grid-small']">
        </div>
      </router-link>

      <div v-if='language === "nl"'
           class='description secondary-color small-text'
           v-html='item.acf.excerpt'></div>
      <div v-if='language === "en"'
           class='description secondary-color small-text'
           v-html='item.acf.excerpt_en'></div>

    </div>

  </div>
</template>
</template>

<script>
import dsTagItemInline from './dsTagItemInline'

export default {
  name: 'dsGridItem',
  props: ['language', 'item', 'tags', 'location', 'screenSize'],
  components: {
    dsTagItemInline
  },
  computed: {
    classList() {
      if (this.location.programma) {
        var classObj = {}
        if (this.item.categories) {
          this.item.categories.forEach(category => {
            classObj['category-' + category] = true
          })
          return classObj
        }
      } else {
        return
      }
    }
  }
}
</script>

<style lang='scss'>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';

.grid-item {
  margin-bottom: 3 * $baseline;
  width: 320px;
  .author {
    span {
      height: $baseline;
      margin-bottom: $baseline;
      position: relative;
      top: -4px;
    }
  }
  .title {
    @include screen-size ('x-small') {
      width: 280px !important;
      white-space: normal;
    }
    // margin-bottom: 1 * $baseline;
    span {
      line-height: 3 * $baseline;
      position: relative;
      top: -1px;
      font-size: $large-text;
    }
  }
  .description {
    @include screen-size ('x-small') {
      width: 280px !important;
      white-space: normal;
      margin-bottom: 3 * $baseline;
    }
    span {
      height: 8 * $baseline;
      margin-bottom: $baseline;
      position: relative;
      top: -4px;
    }
  }
  a {
    border: 0;
  }
  @include screen-size ('x-small') {
    max-width: $column;
  }
  a:active,
  a:hover {
    border: 0;
    .title {
      color: $high-light;
    }
    ~ .description {
      color: $main-color;
    }
    .image-container {
      // background: $high-light;
      img {
        filter: none;
        opacity: 1;
        cursor: pointer;
        mix-blend-mode: multiply;
      }
    }
  }
}

.image-container {
  line-height: 0;
  margin-bottom: $baseline;
  height: 22 * $baseline;
  width: $column;
  @include screen-size ('x-small') {
    display: block;
    object-fit: cover;
    width: 90%;
    display: inline-block;
  }
  img {
    height: 100%;
    object-fit: cover;
    background: $main-color;
    opacity: 0.449;
    filter: grayscale(1);
    width: 100%;
    &[lazy='loaded'] {
      transition: none;
      opacity: 0.449;
      background: transparent;
    }
  }
}

.tags {
  padding-right: $baseline;
  margin-bottom: 1 * $baseline;
}
</style>



// WEBPACK FOOTER //
// dsGridItem.vue?074b1e41